var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flattenTree && _vm.flattenTree.length
    ? _c(
        _vm.treeScrollerConfig.is,
        _vm._b(
          {
            ref: "virtualScrollerCompRef",
            tag: "component",
            attrs: { items: _vm.flattenTree },
            scopedSlots: _vm._u(
              [
                _vm.$slots.before
                  ? {
                      key: "before",
                      fn: function () {
                        return [_vm._t("before")]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "default",
                  fn: function (ref) {
                    var node = ref.item
                    var index = ref.index
                    var active = ref.active
                    return [
                      _c(
                        _vm.itemScrollerConfig.is,
                        _vm._b(
                          {
                            tag: "component",
                            attrs: {
                              item: node,
                              active: active,
                              "data-index": index,
                              "size-dependencies": _vm.itemScrollerConfig.bind
                                .sizeDependencies
                                ? _vm.itemScrollerConfig.bind.sizeDependencies(
                                    node
                                  )
                                : [],
                            },
                          },
                          "component",
                          _vm.itemScrollerConfig.bind,
                          false
                        ),
                        [
                          _vm._t(
                            _vm.$scopedSlots.node || _vm.$slots.node
                              ? "node"
                              : "default",
                            function () {
                              return [_vm._v(" " + _vm._s(node.key) + " ")]
                            },
                            null,
                            {
                              node: node,
                              index: index,
                              active: active,

                              data: node.data,
                              toggleNodeExpand: _vm.toggleNodeExpand,
                              collapseNode: _vm.collapseNode,
                              expandNode: _vm.expandNode,
                              isShowExpandIcon:
                                !node.isLeaf &&
                                !_vm.hiddenExpandIconKeyMap[node.key],
                              isExpand: _vm.expandNodeKeyMap[node.key],

                              toggleCheck: _vm.toggleCheck,
                              isChecked: _vm.checkNodeKeyMap[node.key],
                              isHalfCheck: _vm.halfCheckNodeKeyMap[node.key],
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  },
                },
                _vm.$slots.after
                  ? {
                      key: "after",
                      fn: function () {
                        return [_vm._t("after")]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          "component",
          _vm.treeScrollerConfig.bind,
          false
        )
      )
    : _c(
        "div",
        { tag: "component" },
        [
          _vm._t("empty", function () {
            return [_vm._v(" Empty slot ")]
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }